(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mediaQuery = window.matchMedia('(min-width: 1024px)');
    const headings = document.querySelectorAll('[data-desktop-font-size]');

    function updateFontSizes() {
      headings.forEach(el => {
        if (mediaQuery.matches) {
          el.style.fontSize = el.getAttribute('data-desktop-font-size');
        } else {
          el.style.fontSize = el.getAttribute('data-mobile-font-size');
        }
      });
    }

    updateFontSizes();
    mediaQuery.addListener(updateFontSizes);
  });

  } catch(e) { console.error(e); }
})();
})();
